import { render } from "./SPManagementVue.vue?vue&type=template&id=1f19cd9d&scoped=true"
import script from "./SPManagementVue.vue?vue&type=script&lang=js"
export * from "./SPManagementVue.vue?vue&type=script&lang=js"

import "./SPManagementVue.vue?vue&type=style&index=0&id=1f19cd9d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f19cd9d"]])

export default __exports__